<ng-container *ngTemplateOutlet="isFlexColumn() ? complexTemplate : regularTemplate" />

<ng-template #complexTemplate>
  @if (noOfSummaryColumns() > 0) {
    <div class="td-wb-linear-list__flex--column-header">
      @for (header of rows() | slice: 0 : noOfSummaryColumns(); track header) {
        <ng-container [ngTemplateOutlet]="header.templateRef" />
      }
    </div>
  }
  @for (column of contentRows(); track column) {
    <ng-container [ngTemplateOutlet]="column.templateRef" />

  }
</ng-template>

<ng-template #regularTemplate>
  @if (rows() !== undefined) {
    @for (column of rows(); track column) {
      <ng-container [ngTemplateOutlet]="column.templateRef" />
    }
  }
  <ng-content />
</ng-template>

